import {getCurrentYear} from '../../utils/commons'
import MyPoundSaverLogo from './logo'
import {myPoundSaverStylesUK} from './styles'

const baseConfig = {
  domainName: 'mypoundsaver' as const,
  domainType: 'picks' as const,
  siteName: 'My Pound Saver',
  favicon: '/favicons/mypoundsaver.png',
}

const localeConfigs = {
  uk: {
    measurementId: 'G-NM72E4RHTN',
    camelCaseUrl: 'MyPoundSaver.co.uk',
    logo: <MyPoundSaverLogo className="size-10 shrink-0 tablet:size-6" />,
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the UK | MyPoundSaver.co.uk – Smart Deals & Trusted Picks`,
    description: (_category?: string, _count?: string) =>
      `At MyPoundSaver.co.uk, we uncover the best products and deals across the UK. Explore expert reviews, top-rated picks, and money-saving insights to get the most value for every pound you spend.`,
    styles: myPoundSaverStylesUK,
  },
}

export const createConfig = (locale: string = 'uk') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.uk
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
